import MiniSearch from "minisearch";
import type { SearchIndexDoc } from "../../src/types";

export type SearchHit = SearchIndexDoc & { score: number };

export async function loadSearchIndex(
  url = "/data/search-index.json"
): Promise<MiniSearch<SearchIndexDoc>> {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`failed to load search index: ${resp.status}`);
  const json = await resp.text();
  return MiniSearch.loadJSON<SearchIndexDoc>(json, {
    fields: ["title", "description"],
    storeFields: ["restaurantSlug", "mealPeriod", "groupName", "title", "description"],
    idField: "id",
  });
}

export function searchMenuItems(
  ms: MiniSearch<SearchIndexDoc>,
  query: string,
  limit: number
): SearchHit[] {
  const trimmed = query.trim();
  if (!trimmed) return [];
  const raw = ms.search(trimmed, { prefix: true, fuzzy: 0.2 });
  return raw.slice(0, limit).map((r) => ({
    id: String(r.id),
    restaurantSlug: r.restaurantSlug,
    mealPeriod: r.mealPeriod,
    groupName: r.groupName,
    title: r.title,
    description: r.description,
    score: r.score,
  }));
}
